import * as React from 'react'

import InputAdornment                from '@material-ui/core/InputAdornment'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import Search                        from '@material-ui/icons/Search'

const searchFieldInputProps = {
  startAdornment:
    (
      <InputAdornment position="start">
        <Search />
      </InputAdornment>
    )
}

const SearchField: React.SFC<TextFieldProps> = props => {
  return (
    <TextField
      fullWidth
      InputProps={searchFieldInputProps}
      {...props}
    />
  )
}

export default SearchField



// WEBPACK FOOTER //
// ./src/components/atoms/SearchField.tsx